import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../../../core/http.service';
import { BaseRepositoryImpl } from '../../base-repository-impl';
import { AttEmployeeDailyDeductionModel, AttEmployeeDailyDeductionResponse } from '../../../../domain/models/Hr-Management/attendance/att-employee-daily-deduction.model';
import { AttEmployeeDailyDeductionRepository } from '../../../../domain/interfaces/repositories/HrManagment/attendance/att-employee-daily-deduction-repository.interface';
@Injectable({
  providedIn: 'root',
})
export class AttEmployeeDailyDeductionRepositoryImplService
  extends BaseRepositoryImpl<
    AttEmployeeDailyDeductionModel,
    AttEmployeeDailyDeductionResponse
  >
  implements AttEmployeeDailyDeductionRepository {

  constructor(http: HttpService) {
    super(http, 'AttEmployeeDailyDeduction/');
  }

  getFiltered(filters: {
    companyId?: string;
    employeeId?: number;
    attendanceDate?: string;
    type?: number;
    attDelayEarlyLeaveId?: number;
    fromDate?: string;
    toDate?: string;
    status?: number;
    page?: number;
    pageSize?: number;
  }): Observable<AttEmployeeDailyDeductionResponse> {

    const params = new URLSearchParams();

    if (filters.companyId) params.append('companyId', filters.companyId);
    if (filters.employeeId !== undefined)
      params.append('EmployeeId', filters.employeeId.toString());
    if (filters.attendanceDate)
      params.append('AttendanceDate', filters.attendanceDate);
    if (filters.type !== undefined)
      params.append('Type', filters.type.toString());
    if (filters.status !== undefined)
      params.append('Status', filters.status.toString());
    if (filters.attDelayEarlyLeaveId !== undefined)
      params.append(
        'AttDelayEarlyLeaveId',
        filters.attDelayEarlyLeaveId.toString()
      );
    if (filters.fromDate) params.append('FromDate', filters.fromDate);
    if (filters.toDate) params.append('ToDate', filters.toDate);

    params.append('page', (filters.page ?? 1).toString());
    params.append('pageSize', (filters.pageSize ?? 10).toString());

    return this.http.getData<AttEmployeeDailyDeductionResponse>(
      `${this.baseUrl}GetWithFilter?${params.toString()}`
    );
  } 
  

  /** att_review_01: a percentage set by hand on a 0% "no rule" row (needs the Approve permission; approves the row; audited). */
  setManualPercent(id: number, percent: number): Observable<AttEmployeeDailyDeductionResponse> {
    return this.http.putData<any, AttEmployeeDailyDeductionResponse>(`${this.baseUrl}ManualPercent?id=${id}&percent=${percent}`, {});
  }

/** att_review_02: one decision (approve / reject / back to pending) with an optional note; needs the Approve right. */
  decide(id: number, status: number, note: string, asAdjustment = false): Observable<AttEmployeeDailyDeductionResponse> {
    return this.http.putCoded<any, AttEmployeeDailyDeductionResponse>(`${this.baseUrl}UpdateStatus`, { id, status, note, asAdjustment });
  }

  /** att_review_02: decides many rows at once (all or nothing). */
  decideMany(ids: number[], status: number, note: string, asAdjustment = false): Observable<any> {
    return this.http.putCoded<any, any>('Attendance/decisions', { ids, kind: 'deduction', status, note, asAdjustment });
  }

}
  

